import styled from 'styled-components'

export const Container = styled.div`
  margin-left: 6.5rem;
  margin-right: 6.5rem;
`

Container.displayName = 'Container'

export const ContainerAccessSection = styled.div`
  gap: 1rem;
`

ContainerAccessSection.displayName = 'ContainerAccessSection'
